class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 500));
    let e = this.querySelector("form");
    e.addEventListener("input", this.debouncedOnSubmit.bind(this));
    let t = this.querySelector("#FacetsWrapperDesktop");
    t && t.addEventListener("keyup", onKeyUpEscape);
  }
  static setListeners() {
    let e = (e) => {
      let t = e.state
        ? e.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev &&
        FacetFiltersForm.renderPage(t, null, !1);
    };
    window.addEventListener("popstate", e);
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    let i = FacetFiltersForm.getSections(),
      s = document.getElementById("ProductCount"),
      a = document.getElementById("ProductCountDesktop");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading"),
      s && s.classList.add("loading"),
      a && a.classList.add("loading"),
      i.forEach((r) => {
        let i = `${window.location.pathname}?section_id=${r.section}&${e}`,
          s = (e) => e.url === i;
        FacetFiltersForm.filterData.some(s)
          ? FacetFiltersForm.renderSectionFromCache(s, t)
          : FacetFiltersForm.renderSectionFromFetch(i, t);
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((r) => {
        let i = r;
        (FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: i, url: e },
        ]),
          FacetFiltersForm.renderFilters(i, t),
          FacetFiltersForm.renderProductGridContainer(i),
          FacetFiltersForm.renderProductCount(i),
          "function" == typeof initializeScrollAnimationTrigger &&
            initializeScrollAnimationTrigger(i.innerHTML);
      });
  }
  static renderSectionFromCache(e, t) {
    let r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t),
      FacetFiltersForm.renderProductGridContainer(r),
      FacetFiltersForm.renderProductCount(r),
      "function" == typeof initializeScrollAnimationTrigger &&
        initializeScrollAnimationTrigger(r.innerHTML);
  }
  static renderProductGridContainer(e) {
    (document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("ProductGridContainer").innerHTML),
      document
        .getElementById("ProductGridContainer")
        .querySelectorAll(".scroll-trigger")
        .forEach((e) => {
          e.classList.add("scroll-trigger--cancel");
        });
  }
  static renderProductCount(e) {
      $(".card__media .media").slick({
        slidesToShow: 1,
        slidesToSscroll: 1,
        swipeToSlide: !1,
        arrows: !0,
        draggable: !0,
        fade: !0,
        cssEase: "cubic-bezier(0.3, 0, 0.6, 1)",
        touchThreshold: 100,
        prevArrow:
          '<div class="cardmedia slick-prevss" type="button"><img src="https://cdn.shopify.com/s/files/1/0605/6548/7753/files/arrow-btm.png?v=1698036871"></div>',
        nextArrow:
          '<div class="cardmedia slick-nextss" type="button"><img src="https://cdn.shopify.com/s/files/1/0605/6548/7753/files/arrow-btm.png?v=1698036871"></div>',
        responsive: [
          {
            breakpoint: 1366,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
          },
          { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
          { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
          { breakpoint: 524, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      }),
      $(".card__content .lsp_var img").click(function () {
        var e = $(this).attr("vf");
        if (e.length) {
          var t = $(this)
            .parents(".card-wrapper.product-card-wrapper.underline-links-hover")
            .find(".sec_slider_div");
          t.slick("slickUnfilter"),
            t.find(`.slick-slide[data-color="${e}"]`).length &&
              t.slick("slickFilter", function t() {
                return (
                  $(this).data("color") === e || "" === $(this).data("color")
                );
              });
        }
        $(".fluid_img1").show(),
          $(this)
            .parent()
            .addClass("active_size")
            .siblings()
            .removeClass("active_size");
        var r = $(this).attr("vf"),
          i = $(this)
            .parents(".card--standard.card--media")
            .find(".card__inner .size_lsp .active_size")
            .attr("tr");
        let s = $(
          '.card__content .vari_hide_loop .Hide_lopping[hid="' +
            i +
            " / " +
            r +
            '"]'
        ).attr("data-id");
        $(".card__inner button#Collection_addtocard").attr("newid", s);
      }),
      $(".card__inner ul.size_lsp li").click(function () {
        $(this).addClass("active_size").siblings().removeClass("active_size");
        var e = $(this).attr("tr"),
          t = $(this)
            .parents(".card--standard.card--media")
            .find(".card__content .lsp_var.swiper-slide-active")
            .attr("vf");
        let r = $(
          '.card__content .vari_hide_loop .Hide_lopping[hid="' +
            e +
            " / " +
            t +
            '"]'
        ).attr("data-id");
        $(".card__inner button#Collection_addtocard").attr("newid", r);
      });
    let t = new DOMParser()
        .parseFromString(e, "text/html")
        .getElementById("ProductCount").innerHTML,
      r = document.getElementById("ProductCount"),
      i = document.getElementById("ProductCountDesktop");
    (r.innerHTML = t),
      r.classList.remove("loading"),
      i && ((i.innerHTML = t), i.classList.remove("loading"));
  }
  static renderFilters(e, t) {
    let r = new DOMParser().parseFromString(e, "text/html"),
      i = r.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
      ),
      s = (e) => {
        let r = t ? t.target.closest(".js-filter") : void 0;
        return !!r && e.dataset.index === r.dataset.index;
      },
      a = Array.from(i).filter((e) => !s(e)),
      l = Array.from(i).find(s);
    a.forEach((e) => {
      document.querySelector(
        `.js-filter[data-index="${e.dataset.index}"]`
      ).innerHTML = e.innerHTML;
    }),
      FacetFiltersForm.renderActiveFacets(r),
      FacetFiltersForm.renderAdditionalElements(r),
      l && FacetFiltersForm.renderCounts(l, t.target.closest(".js-filter"));
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      let r = e.querySelector(t);
      r && (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderAdditionalElements(e) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(
      (t) => {
        e.querySelector(t) &&
          (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
      }
    ),
      document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
  }
  static renderCounts(e, t) {
    let r = t.querySelector(".facets__selected"),
      i = e.querySelector(".facets__selected"),
      s = t.querySelector(".facets__summary"),
      a = e.querySelector(".facets__summary");
    i &&
      r &&
      (t.querySelector(".facets__selected").outerHTML =
        e.querySelector(".facets__selected").outerHTML),
      s &&
        a &&
        (t.querySelector(".facets__summary").outerHTML =
          e.querySelector(".facets__summary").outerHTML);
  }
  static updateURLHash(e) {
    history.pushState(
      { searchParams: e },
      "",
      `${window.location.pathname}${e && "?".concat(e)}`
    );
  }
  static getSections() {
    return [{ section: document.getElementById("product-grid").dataset.id }];
  }
  createSearchParams(e) {
    let t = new FormData(e);
    return new URLSearchParams(t).toString();
  }
  onSubmitForm(e, t) {
    FacetFiltersForm.renderPage(e, t);
  }
  onSubmitHandler(e) {
    e.preventDefault();
    let t = document.querySelectorAll("facet-filters-form form");
    if ("mobile-facets__checkbox" == e.srcElement.className) {
      let r = this.createSearchParams(e.target.closest("form"));
      this.onSubmitForm(r, e);
    } else {
      let i = [],
        s = "FacetFiltersFormMobile" === e.target.closest("form").id;
      t.forEach((e) => {
        if (s)
          "FacetFiltersFormMobile" === e.id &&
            i.push(this.createSearchParams(e));
        else if (
          "FacetSortForm" === e.id ||
          "FacetFiltersForm" === e.id ||
          "FacetSortDrawerForm" === e.id
        ) {
          let t = document.querySelectorAll(".no-js-list");
          t.forEach((e) => e.remove()), i.push(this.createSearchParams(e));
        }
      }),
        this.onSubmitForm(i.join("&"), e);
    }
  }
  onActiveFilterClick(e) {
    e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    let t =
      -1 == e.currentTarget.href.indexOf("?")
        ? ""
        : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(t);
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) =>
        e.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    let e = this.querySelectorAll("input"),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute("max", r.value),
      t.value && r.setAttribute("min", t.value),
      "" === t.value && r.setAttribute("min", 0),
      "" === r.value && t.setAttribute("max", r.getAttribute("max"));
  }
  adjustToValidValues(e) {
    let t = Number(e.value),
      r = Number(e.getAttribute("min")),
      i = Number(e.getAttribute("max"));
    t < r && (e.value = r), t > i && (e.value = i);
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector("a");
    e.setAttribute("role", "button"),
      e.addEventListener("click", this.closeFilter.bind(this)),
      e.addEventListener("keyup", (e) => {
        e.preventDefault(),
          "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
      });
  }
  closeFilter(e) {
    e.preventDefault();
    let t =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    t.onActiveFilterClick(e);
  }
}
customElements.define("facet-remove", FacetRemove);
